var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{class:_vm.componentClass},[_c('HeaderV2ControlBtnAtom'),_c('HeaderV2LogoAtom'),(_vm.isUserCompanyHasParent())?_c('EIcon',{attrs:{"name":"logo-ebk","width":"60px"}}):_vm._e(),_c('HeaderV2ProjectListAtom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }